import { postToDTonomyAPI } from "./common";
import { Link } from "./link";

export async function submitUrlsForScanning(urls){
    //TODO: return from cache if exists
    //const links = await getLinksFromHtml();
    //const urls = links.map(link => link.href);
    // Post to base.plugin DTonomy API
    if(urls){
      return await postToDTonomyAPI("urlscan/submissions/", {"urls": urls});
    }
    else{
      console.log("The urls argument is undefined")
    }
  }
  
export  async function fetchUrlScanResult(webpageUrl){
    if(webpageUrl){
      return await postToDTonomyAPI("urlscan/result/", {"url": webpageUrl});
    }
    else{
      console.log("The given webpageUrl parameter is undefined")
    }
  }
  
  
export async function fetchUrlScanResults(webpageUrls){
    if(webpageUrls){
      return await postToDTonomyAPI("urlscan/results/", {"urls": webpageUrls});
    }
    else{
      console.log("The given webpageUrls parameter is undefined")
    }
  }
  

export async function fetchCompletedUrlScanResults(webpageUrls){
  if(webpageUrls){
    return await postToDTonomyAPI("urlscan/completed_results/", {"urls": webpageUrls});
  }
  else{
    console.log("The given webpageUrls parameter is undefined")
  }
}


/**
* Creates a DOMParser object from the given html string
* and utilizes the parsed links objects to return
* and array of Link objects for urls that contains https or http
* @returns {Array<Link>}
*/
export function parseWebPageLinksFromHtml(html){
  const htmlDocument = new DOMParser().parseFromString(html, "text/html");
  const links = [];
  if(htmlDocument && htmlDocument.links){
    for(var i=0; i<  htmlDocument.links.length; i++) {
      const link = htmlDocument.links[i];
      // Since We are using the URLs for UrlScan, and UrlScan expects a web page
      // We can assume that the relevant hyperlinks will have https or http protocols
      if(link.protocol === "https:" || link.protocol === "http:"){
        links.push(new Link(link.href,link.text));
      }
    }
  }
  return links;
}
  